<template>
  <div ref="chart" :class="className" :style="{height:height,width:width, minHeight: '160px'}"></div>
</template>

<script>
import echarts from 'echarts'
// const animationDuration = 6000

export default {
  name: 'rader-charts',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    options: {
      type: Object,
      default () {
        return {
          title: {
            text: 'ECharts 入门示例'
          },
          tooltip: {},
          xAxis: {
            data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
          },
          yAxis: {},
          series: [
            {
              name: '销量',
              type: 'bar',
              data: [5, 20, 36, 10, 10, 20]
            }
          ]

        }
      }
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    });
    this.objResize = new ResizeObserver(() => {
      if (this.chart) {
        this.chart.resize();
      }
    });
    this.objResize.observe(this.$refs.chart);
  },
  watch: {
    options: {
      handler () {
        this.chart.setOption(this.options)
      },
      deep: true
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.options)
    },
    setOptions (options) {
      this.chart.setOption(options)
    }
  },

}
</script>
